if($('.type-category').length){
    document.addEventListener('ShoptetDOMPageContentLoaded', function() {
        customCategory();
    });
    document.addEventListener('ShoptetPageSortingChanged', function() {
        customCategory();
    });
    document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
        customCategory();
    });
    $(document).ready(function(){
        customCategory();
    });
}

function customCategory(){
    if($('.subcategories li').length){
        $('.subcategories li img').each(function(){
            const $img = $(this)
            let image = $img.attr('data-src');
            image = image.replace('/thumb/', '/orig/');
            $(this).attr('data-src', image)
        })
    }
    if(!$('.category-header span.customSort').length){
        $('.category-header').append('<span class="customSort">'+$('.listSorting__controls .listSorting__control--current').text().trim()+'</span>')
    }
    $('html').on('click', '.customSort', function(){
        $('.listSorting').toggleClass('OpetCustosort');
    })
    var path = window.location.pathname;
    $.each(urlList, function (_, url) {
        if (path.indexOf(url) === 0) {
            var bodyClass = 'categoryWithoutProducts'
            $('body').addClass(bodyClass);
        }
    });
    if(!$('#category-filter-hover').length){
        $('.filter-sections').append('<div id="category-filter-hover"></div>')
    }
    $('#category-filter-hover').append($('.filters-wrapper .slider-wrapper').addClass('filter-section'))
   
    if(!$('#filters-wrapper .filterTitle').length){
        $('#filters-wrapper').prepend('<span class="filterTitle">'+translation('nadpisFiltrace')+'</span>')
    }
    $('.filter-section:has(label.active)').addClass('activefilterList');
}

 $('html').on('click', '.filter-section h4', function(){
    $(this).closest('.filter-section').toggleClass('activefilterList')
});
